import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { TimeApi } from '../../../core/api/time.api';
import { MobileComponent } from '../../../shared/components/mobile/mobile.component';

@Component({
  selector: 'app-time-clock',
  templateUrl: './clock.component.html',
  styleUrl: './clock.component.scss',
})
export class ClockComponent extends MobileComponent implements OnInit {
  lastSync: Date = new Date();
  time: Date = new Date();

  constructor(
    breakpointObserver: BreakpointObserver,
    private timeApi: TimeApi
  ) {
    super(breakpointObserver);
  }

  ngOnInit(): void {
    this.updateTime();
    setInterval(() => this.updateTime(), 1000);
  }

  get timeFormatted(): string {
    return this.time?.toLocaleTimeString();
  }

  get tooltip(): string {
    return `Last synced at ${this.lastSync?.toLocaleTimeString()}`;
  }

  private updateTime(): void {
    if (this.lastSync.getTime() + 300000 < new Date().getTime()) {
      this.timeApi.getTime().subscribe(time => {
        this.lastSync = new Date();
        this.time = new Date(time);
      });
    } else {
      this.time.setSeconds(this.time.getSeconds() + 1);
    }
  }
}
